import * as Type from 'library/ts/utilities/modules/Type';
export const processCustParams = (custParams, encode = true) => {
    if (Type.isString(custParams) === false)
        return custParams;
    const decodeList = [
        {
            searchValue: new RegExp(/%3D/g),
            replaceValue: '='
        },
        {
            searchValue: new RegExp(/%26/g),
            replaceValue: '&'
        },
        {
            searchValue: new RegExp(/%2C/g),
            replaceValue: ','
        }
    ];
    const encodeList = [
        {
            searchValue: new RegExp(/=/g),
            replaceValue: '%3D'
        },
        {
            searchValue: new RegExp(/&/g),
            replaceValue: '%26'
        },
        {
            searchValue: new RegExp(/,/g),
            replaceValue: '%2C'
        }
    ];
    const list = (encode === true ? encodeList : decodeList);
    list.forEach((item) => {
        custParams = String(custParams).replace(item.searchValue, item.replaceValue);
    });
    return custParams;
};
export const getCorrelator = () => {
    let n = String(Math.round(1000000000000000 + Math.random() * 9000000000000000));
    if (n.length < 16) {
        while (n.length < 16)
            n += '0';
    }
    if (n.length > 16) {
        n = n.substr(0, 17);
    }
    return n;
};
